/**
 * The account the next GraphQL request should be scoped to, as the Apollo link
 * needs it: synchronously, at the moment a request is dispatched.
 *
 * This deliberately lives outside React. `AccountProvider` also mirrors the
 * value into a jotai atom for components that want to re-render on a change,
 * but an atom cannot be the source of truth for the link: it is set from an
 * effect, so it is still stale while the subtree that reads it first renders —
 * and Apollo's `useQuery` starts its request during render. Publishing here
 * instead makes the value correct before any child renders, which is what
 * allows `AccountProvider` to render children immediately rather than
 * withholding them for a render pass.
 */
let currentAccountId: string | null = null;

export function setCurrentAccountIdScope(accountId: string | null) {
  currentAccountId = accountId;
}

export function getCurrentAccountIdScope() {
  return currentAccountId;
}
